import history from '../../util/history'

const cancelCreateView = () => {
  history.push('/segment_settings')

  return true
}

export default cancelCreateView
